var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SkeletonTheme',{attrs:{"color":_vm.$store.state.theme==='dark' ? '#10163A' : '#eeeeee',"highlight":_vm.$store.state.theme==='dark' ? '#262C47' : '#f5f5f5'}},[_c('Skeleton',_vm._b({attrs:{"height":_vm.height}},'Skeleton',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }